module.exports = __webpack_public_path__ + "resources/img/zoom-ui-customizations-08.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/zoom-ui-customizations-08.png
// module id = 1404
// module chunks = 0